/**
 * Detects and ignores errors caused by the iOS Google Search App using the Google Translate API
 *
 * @param {object} report the Report Object
 * @returns {boolean} Returns true if the report matches
 * @example
 *   "a[b].target.className.indexOf is not a function. (In 'a[b].target.className.indexOf(bc)', 'a[b].target.className.indexOf' is undefined)"
 */
function gsaTypeError(report) {
  if (report.errorMessage.includes("'a[b].target.className.indexOf(bc)") && navigator.userAgent.includes("GSA")) {
    report.ignore();

    return true;
  }

  return false;
}

export default gsaTypeError;
